export default __webpack_public_path__ + "static/media/Book_4.bec486cc.png";